import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import noop from "lodash/noop";
import DisplayElement from "../DisplayElement/index.js";
const DisplayButton = _ref => {
  let {
    disabled,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(DisplayElement, _extends({
    as: "button",
    htmlDisabled: disabled
  }, props));
};
DisplayButton.defaultProps = {
  onClick: noop,
  type: 'button'
};
process.env.NODE_ENV !== "production" ? DisplayButton.propTypes = {
  /**
   * Disable button
   */
  disabled: PropTypes.bool,
  /**
   * Click handler. Not required for links. Other `DisplayLink` properties can also be passed.
   */
  onClick: PropTypes.func,
  /**
   * button type. See [MDN's <button> page](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#attr-type) for more details
   */
  type: PropTypes.oneOf(['button', 'reset', 'submit'])
} : void 0;
export default DisplayButton;